import type {LucideIcon} from 'lucide-react';
import {GlobeIcon, LinkIcon, LockIcon, UsersIcon} from 'lucide-react';
import {CollectionModel} from '../../api/types.ts';

export type VisibilityTint = 'private' | 'link' | 'group' | 'public';

export interface Visibility {
    icon: LucideIcon;
    label: string;
    tint: VisibilityTint;
    // Longer wording for the tooltip, e.g. the list of groups.
    title?: string;
}

export const privateVisibility: Visibility = {
    icon: LockIcon,
    label: 'Private',
    tint: 'private',
    title: 'Only you and your editors'
};

export const linkVisibility: Visibility = {
    icon: LinkIcon,
    label: 'Anyone with the link',
    tint: 'link'
};

export const publicVisibility: Visibility = {
    icon: GlobeIcon,
    label: 'Public',
    tint: 'public',
    title: 'Anyone, and it appears on your portfolio and in Explore'
};

// Who can see a project, from the collections it has been shared to. Any
// public collection makes it public; otherwise the named groups; otherwise
// only the owner and editors.
export function visibilityOf(project: {
    collections: CollectionModel[];
}): Visibility {
    const collections = project.collections ?? [];

    if (collections.some(c => c.public)) {
        return publicVisibility;
    }

    if (collections.length === 1) {
        return {
            icon: UsersIcon,
            label: collections[0].name,
            tint: 'group',
            title: `Members of ${collections[0].name}`
        };
    }

    if (collections.length > 1) {
        return {
            icon: UsersIcon,
            label: `${collections.length} groups`,
            tint: 'group',
            title: collections.map(c => c.name).join(', ')
        };
    }

    return privateVisibility;
}
